import { FiltersWithQuery } from "../../components/filters";
import { Column, Row } from "../../components/grid";
import { PageLayout } from "../../components/page-layout";
import { SearchWithQueryInput } from "../../components/search-input";
import useMyTasks from "./useMyTasks";
import { tasksTableHeaders } from "../../entities/ITask";
import TaskBulkActions from "../../components/task-bulk-actions/TaskBulkActions";
import { TableWithQueryPaginationAndSort } from "../../components/table/TableWithQueryPaginationAndSort";
import { tasksTableFilters } from "../tasks/TasksScreen.types";
import { useTranslation } from "react-i18next";
const MyTasksScreen = () => {
  const {
    myTasks,
    loading,
    onRowPress,
    total,
    setSelectedTasks,
    selectedTasks,
    selectedAction,
    setSelectedAction,
    reassignBulkTasks,
    reassigningTasks,
    moveBulkTasks,
    movingTasks,
  } = useMyTasks();
  const { t } = useTranslation();
  return (
    <PageLayout
      title={t("MY_TASK.TITLE")}
      filter={<FiltersWithQuery filters={tasksTableFilters(["user=>id", "createdBy=>id"], t)} />}
      search={<SearchWithQueryInput placeHolder={t("TASKS.SEARCH")} />}
    >
      <div className="flex-column gap-2">
        <TaskBulkActions
          selectedTasks={selectedTasks}
          onDismiss={() => {
            setSelectedTasks([]);
          }}
          selectedAction={selectedAction}
          setSelectedAction={setSelectedAction}
          onReassign={reassignBulkTasks}
          reassigning={reassigningTasks}
          moving={movingTasks}
          onMove={moveBulkTasks}
        />
        <Row>
          <Column>
            <TableWithQueryPaginationAndSort
              loading={loading}
              onRowPress={onRowPress}
              headers={tasksTableHeaders.filter(
                (item) => item.key !== "assignee.name" && item.key !== "createdBy.name"
              )}
              data={myTasks}
              totalItems={total}
              selection={false}
            />
          </Column>
        </Row>
      </div>
    </PageLayout>
  );
};
export default MyTasksScreen;
